"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attribute = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const attribute_value_component_1 = require("./attribute-value.component");
const attributes_styles_1 = require("./attributes.styles");
// commented out for EN-3066
// import { WarningIcon } from '@/enrich/icons';
const hooks_1 = require("../../../hooks");
const Attribute = ({ attribute, displayValueOnly, }) => {
    const { name, values = [] } = attribute;
    // commented out for EN-3066
    // const { name, active: isAttributeActive, values = [] } = attribute;
    const attributeNameRef = (0, react_1.useRef)(null);
    const isAttributeOverflowing = (0, hooks_1.useIsTextOverflowing)(attributeNameRef);
    // commented out for EN-3066
    // const titleIcon = !isAttributeActive && <WarningIcon />;
    const attributeText = react_1.default.createElement("span", { ref: attributeNameRef, className: 'attribute-text' }, name);
    // commented out for EN-3066
    // eslint-disable-next-line max-len
    // const attributeText = <span ref={attributeNameRef} className={cn('attribute-text', { 'attribute-text--crossed-out': !isAttributeActive })}>{name}</span>;
    return (react_1.default.createElement(react_1.default.Fragment, null, !displayValueOnly && (react_1.default.createElement(attributes_styles_1.StyledAttributeContainerCell, null, isAttributeOverflowing
        ? react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, title: name }, attributeText)
        : attributeText)), react_1.default.createElement(attribute_value_component_1.AttributeValue, { values: values })));
};
exports.Attribute = Attribute;
exports.default = exports.Attribute;
